import React, { FC } from 'react';
import { UpdateCaddyErrorCode, DeleteCaddyErrorCode } from '@bechtel/types';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { CaddyErrorProps } from './types';

const getErrorMessage = (error: CaddyErrorProps['caddyError']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case UpdateCaddyErrorCode.INVALID_CADDY_ID:
      return <Trans>Invalid Caddy ID</Trans>;
    case UpdateCaddyErrorCode.UPDATE_CADDY_MUTATION_ERROR:
      return <Trans>Error in Update Caddy Mutation.</Trans>;
    case UpdateCaddyErrorCode.MISSING_REQUIRED_PERMISSION:
      return <Trans>Required permissions are missing.</Trans>;
    case DeleteCaddyErrorCode.DELETE_CADDY_MUTATION_ERROR:
      return <Trans>Error while deleting caddy.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

const ErrorModal: FC<CaddyErrorProps> = ({ caddyError, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={t`Caddies Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(caddyError)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};

export default ErrorModal;
